import styled from "styled-components";

const ITEM_HEIGHT = 56;
export const StyledVerticalNavigationItem = styled.li(({ theme }) => ({
    width: "100%",
    cursor: "pointer",
    position: "relative",
    height: ITEM_HEIGHT,
    "& .item-wrapper": {
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        textAlign: "left",
        padding: `${theme.spacing.x9} ${theme.spacing.small} ${theme.spacing.x9} ${theme.spacing.large}`,
        alignSelf: "start",
        height: "100%",
        width: "100%",
    },
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    textAlign: "center",
}));

export const StyledVerticalNavigationItemsList = styled.ul<{
    selectedItemPosition: number;
}>(({ theme, selectedItemPosition }) => {
    const selectedItemIndicatorOffsetTop = `translateY(calc( 0px + ${
        (selectedItemPosition - 1) * ITEM_HEIGHT
    }px ))`;

    return {
        display: "flex",
        flexDirection: "column",
        alignContent: "start",
        height: "100%",
        overflow: "scroll",
        position: "absolute",
        top: 0,
        bottom: 0,
        left: 0,
        margin: 0,
        padding: 0,
        borderRight: `1px solid ${theme.colors[theme.colorMode].border_Tertiary}`,
        background: theme.colors[theme.colorMode].background_Primary,
        width: "45%",

        "&:before": {
            content: "''",
            position: "absolute",
            transition: "transform ease-out 300ms",
            top: 0,
            transform: selectedItemIndicatorOffsetTop,
            left: 0,
            width: 6,
            height: ITEM_HEIGHT,
            borderTopRightRadius: 8,
            borderBottomRightRadius: 8,
            background: theme.colors[theme.colorMode].background_Button_Primary,
        },
        "-ms-overflow-style": "none",
        "scrollbar-width": "none",
        "&::-webkit-scrollbar": { display: "none" },
    };
});

export const StyledVerticalNavigation = styled.div(({ theme }) => ({
    height: "100%",
    overflow: "scroll",
    overflowX: "hidden",
    width: "100%",
    position: "relative",
    ".content": {
        marginLeft: "42%",
        paddingLeft: theme.spacing.xLarge,
        paddingRight: theme.spacing.small,
        height: "100%",
        overflow: "scroll",
        position: "relative",
        ".content": {
            marginLeft: "42%",
            paddingLeft: theme.spacing.xLarge,
            paddingRight: theme.spacing.small,
            height: "100%",
            "overflow-y": "scroll",
        },
    },
}));
